// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"928dd6b4","668":"f9471f5a"}[chunkId] + ".chunk.css";
};